import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Arrow } from '../../icons/arrow';
import { Button } from '../../inputs/button';

import styles from './pageController.module.css';


/**
 * @param {Object} props
 * @param {number} [props.pageIndex=0] The page the api has returned. Starts a 0
 * @param {number} [props.totalPages=0] The total number of pages the api has returned. 1 page starts at 1
 * @param {[number, (number) => void]} props.pageState The requested page state by the client. If a page is properly loaded it's value will be the same as pageIndex. Starts at 0
 * @param {boolean} props.disabled Disable
 */
export const PageController = ({pageIndex = 0, totalPages = 0, pageState, disabled}) => {

    const [inputPage, setInputPage] = useState(pageIndex + 1);

    const keyDown = (e) => {
        if (e.keyCode === 13) {
            e.preventDefault();
            setPage(inputPage - 1);
        }
    }

    useEffect(() => {
        if (!disabled)
            if (pageState[0] > totalPages && totalPages != 0)
                pageState[1](totalPages - 1);
    }, [disabled]);

    useEffect(() => {
        setInputPage(pageIndex + 1)
    }, [pageIndex]);

    const changePage = (i) => {
        pageState[1](pageState[0] + i);
    }

    const setPage = (i) => {
        pageState[1](i);
    }

    if (totalPages === 1)
        return <></>

    return <div className={styles.PageController}>
        <Button
            className={styles.Arrow + ' primary'}
            onClick={() => changePage(-1)}
            disabled={disabled || pageIndex === 0}
        ><Arrow direction='left' /></Button>

        <Button
            className={styles.Range}
            onClick={() => setPage(0)}
            disabled={disabled || pageIndex === 0}
        >1</Button>
        
        <div className={styles.Space}>...</div>

        <input
            type='number'
            disabled={disabled}
            value={inputPage}
            onChange={(e) => {
                setInputPage(Math.max(Math.min(parseInt(e.target.value), totalPages), 1))
            }}
            onBlur={() => setPage(inputPage - 1)}
            onKeyDown={keyDown}
        />

        <div className={styles.Space}>...</div>
        <Button
            className={styles.Range}
            onClick={() => setPage(totalPages - 1)}
            disabled={disabled || pageIndex >= totalPages - 1}
        >{totalPages}</Button>

        <Button
            className={styles.Arrow + ' primary'}
            onClick={() => changePage(1)}
            disabled={disabled || pageIndex >= totalPages - 1}
        ><Arrow direction='right' /></Button>
    </div>
}